import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../pages/Home/Home";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Courses from "../pages/Courses/Courses";
import ProfileDetails from "../pages/ProfileDetails/ProfileDetails";
import Instructors from "../pages/Instructours/Instructours";
import CourseDetails from "../pages/CourseDetails/CourseDetails";
import InstructorDetails from "../pages/InstructorDetails/InstructorDetails";
import AboutUs from "../pages/About/AboutUs";
import Profile from "../pages/Profile/Profile";
import Register from "../pages/Auth/Register";
import Login from "../pages/Auth/Login";
import ForgetPassword from "../pages/Auth/ForgetPassword";
import ChangePassword from "../pages/Auth/ChangePassword";
import OTP from "../pages/Auth/OTP";
import { ToastContainer } from "react-toastify";
import ProtectedOtpRoute from "../pages/Auth/ProtectedRoute";
import VerifyOtp from "../pages/Auth/OTPAnother";
import VerifyAccount from "../pages/Auth/verifyAccount";
import ProfileInfo from "../pages/ProfileInfo/ProfileInfo";
import VerifyAccountOtp from "../pages/Auth/verifyAccountOtp";
import ProtectedRoute from "../components/ProtectedRoute";
import { NotFound } from "../components/NotFound";




export function Applayout() {
  const location = useLocation();
  const hideNavbarFooterPaths = ["/register", "/login", "/forget-password", "/change-password", "/otp"];
  const shouldHideNavbarFooter = hideNavbarFooterPaths.includes(location.pathname);

  return (
    <>
      {!shouldHideNavbarFooter && <Navbar />}
      <ToastContainer autoClose={3000} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/CourseDetails/:id" element={<CourseDetails />} />
        <Route path="/Instructors" element={<Instructors />} />
        <Route path="/instructortDetails/:id" element={<InstructorDetails />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<NotFound />} />

        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profileDetails"
          element={
            <ProtectedRoute>
              <ProfileDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profileInfo/:id"
          element={
            <ProtectedRoute>
              <ProfileInfo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedOtpRoute>
              <ChangePassword />
            </ProtectedOtpRoute>
          }
        />
      
      <Route path="/verify-account" element={<VerifyAccount />} />

      <Route
        path="/otp"
        element={
          <ProtectedOtpRoute>
            <OTP />
          </ProtectedOtpRoute>
        }
      />
      <Route
        path="/verify-otp"
        element={
          <ProtectedOtpRoute>
            <VerifyOtp />
          </ProtectedOtpRoute>
        }
      />
      <Route
        path="/verify-account-otp"
        element={
          <ProtectedOtpRoute>
            <VerifyAccountOtp />
          </ProtectedOtpRoute>
        }
      />


    </Routes >
      {!shouldHideNavbarFooter && <Footer />
}

    </>

  );
}
